import { createGlobalStyle } from "styled-components"

export const GlobalStyles = createGlobalStyle`
  :root {
    /* ------------------------- color ------------------------- */
    --primaryColor: #323232;
    --secondaryColor: #737373;
    --thaiChili: #cf0016;
    --machuPiccuGardens: #90a645;
    --white: #fff;
    --black: #000;
    /* ------------------------- box shadow & border ------------------------- */
    //navbar
    --navbarBoxShadow: 0px 2px 12px #0000001D;
    //button
    --buttonBorderRadious: 10px;
    /*  homepage  */
    //blog section
    --blogItemBoxShadow: 0px 2px 16px #394E5D36;
    --blogImageBorderRadious: 4px;
    /* ------------------------- font size ------------------------- */
    /*  common font size  */
    --commonTitle: 20px;
    //navbar
    --navitem: 15px;
    //button
    --buttonText: 14px;
    //copyright
    --copyrightText: 14px; 
    /*  homepage  */
    //hero
    --heroDetails: 22px;
    --heroText: 26px;
    //section common
    --sectionTitle: 32px;
    //lorem ipsum section
    --loremDetails: 18px;
    //blog section
    --blogSectionDetails: 16px;
     /* ------------------------- font weight ------------------------- */
    --normal: 400;
    --semiBold: 400;
    --bold: 500;
     /* ------------------------- transition ------------------------- */
     --defaultTransition: 0.3s;
     /* ------------------------- navbar height ------------------------- */
     --navbarHeight: 92px;
  }
  *{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  body{
    font-family: 'Lato', sans-serif;
    color: var(--primaryColor);
    font-weight: var(--normal);
    line-height: 1;
  }
    ol, ul {
    list-style: none;
  }
  a {
    text-decoration: none;
    display: inline-block;
  }
`
